import { render } from "./SideMenuHeader.vue?vue&type=template&id=1fe42301&scoped=true"
import script from "./SideMenuHeader.vue?vue&type=script&lang=js"
export * from "./SideMenuHeader.vue?vue&type=script&lang=js"

import "./SideMenuHeader.vue?vue&type=style&index=0&id=1fe42301&scoped=true&lang=stylus"

import exportComponent from "F:\\xampp\\htdocs\\GITLAB\\2026\\tokyo-shoseki\\R9 Site Maintenance January 2026\\08k_serk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe42301"]])

export default __exports__